import { Outlet } from 'react-router-dom';
import Content from '../content';

function Container() {
    return (
        <Content>
            <Outlet />
        </Content>
    );
}

export default Container;
